import { ACADEMY_BASE_URL, BASE_URL } from "App/constants";
import axios from "axios";
import { FetchBatchPerformanceParams } from "Interfaces/Components/Shared/BatchPerformanceInterface";
import { getAcademyId } from "Utils/utils";

export const fetchBatchPerformance = async ({
  academy_id,
  Id,
  startDate,
  endDate,
  page,
  pageSize,
}: FetchBatchPerformanceParams) => {
  try {
    const resolvedAcademyId = getAcademyId(academy_id);
    const userAcademyId = getAcademyId();
    const url = userAcademyId
      ? `${ACADEMY_BASE_URL}${resolvedAcademyId}/players/${Id}/batch_performances`
      : `${BASE_URL}players/${Id}/batch_performances`;

    const { data } = await axios.get(url, {
      params: {
        page,
        start_date: startDate,
        end_date: endDate,
        pageSize: pageSize,
      },
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage =
        error.response?.data?.error || "An unexpected Error has occured";
      throw new Error(errorMessage);
    }
  }
};
